import { render, staticRenderFns } from "./NotificationPetugas.vue?vue&type=template&id=36be03d4&"
import script from "./NotificationPetugas.vue?vue&type=script&lang=js&"
export * from "./NotificationPetugas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports